import { render, createRoot } from '@wordpress/element';
import PageFunctions from './components/PageFunctions';
import TextToSpeech from './components/Text2Speech/Text2Speech';

document.addEventListener('DOMContentLoaded', () => {
  const ttsContainers = document.querySelectorAll('.text-to-speech-container');
  const menuToggles = document.querySelectorAll('.menu-toggle');

  const pageFnContainer = document.getElementById('themePageFn');
  if (pageFnContainer) {
    render(<PageFunctions />, pageFnContainer);
  }

  if (menuToggles) {
    menuToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const navPrimary = document.getElementById('site-navigation');

        navPrimary.classList.toggle('active');
      })
    })
  }

  ttsContainers.forEach(container => {
    const postContentSelector = container.getAttribute('data-post-content');
    const postContent = document.querySelector(postContentSelector);

    if (postContent) {
      render(<TextToSpeech postContent={postContent} />, container);
    }
  });
});
